<template>
  <page-section>
    <integration-promotions-table :integration-id="model.id" />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import IntegrationPromotionsTable from '@/modules/integrations/components/IntegrationPromotionsTable'

export default {
  name: 'TGLabPromotions',
  components: { IntegrationPromotionsTable, PageSection },
  props: {
    model: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/tglab/TGLabPromotions.vue